export default __webpack_public_path__ + "static/media/2425 utensils side.610267bb.png";